import { render, staticRenderFns } from "./FieldPermissionShowData.vue?vue&type=template&id=330d1d0f"
import script from "./FieldPermissionShowData.vue?vue&type=script&lang=js"
export * from "./FieldPermissionShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports